import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Logo from '../../assets/Logo3.svg';
import gplay from '../../assets/gplay.svg';
import appstore from '../../assets/appstore.svg';
import FooterAccordion from './FooterAccordion/FooterAccordion';
import FooterSocials from './FooterSocials/FooterSocials';
import FooterColumns from './FooterColumns/FooterColumns';
import TextLink from '../../components/TextLink/TextLink';
import FooterBottomImage from '../../assets/footer-bottom-image.webp';

const Footer = () => {
    const data = useStaticQuery(query);
    const year = new Date().getFullYear();
    return (
        <footer className="main-footer">
            <div className="main-footer-inner">
                <FooterColumns data={data.allFlotiqMainSettings.nodes[0]} />
                <div className="d-xs-block d-sm-block d-md-none d-lg-none">
                    <div className="main-footer-header">
                        <div className="main-footer-header-logo">
                            <img src={Logo} alt="" />
                        </div>
                        <p>
                            <strong>Download Flotiq App</strong>
                        </p>
                        <div>
                            <TextLink
                                target="_blank"
                                href={
                                    data.allFlotiqMainSettings.nodes[0]
                                        .google_play_url
                                }
                                rel="noreferrer"
                                dataEventLocation="footer_link"
                            >
                                <img src={gplay} alt="" className="store-img" />
                            </TextLink>
                            <TextLink
                                target="_blank"
                                href={
                                    data.allFlotiqMainSettings.nodes[0]
                                        .app_store_url
                                }
                                rel="noreferrer"
                                dataEventLocation="footer_link"
                            >
                                <img
                                    src={appstore}
                                    alt=""
                                    className="store-img"
                                />
                            </TextLink>
                        </div>
                    </div>
                    <FooterAccordion
                        data={data.allFlotiqMainSettings.nodes[0]}
                    />
                </div>
                <div className="main-footer-subfooter">
                    <div className="main-footer-subfooter--opacity text-s">
                        © {year} Flotiq
                    </div>
                    <div className="main-footer-subfooter--opacity">
                        {data.allFlotiqMainSettings.nodes[0].footer_legal.map(
                            ({ text, url, new_tab }) => (
                                <TextLink
                                    key={text + url}
                                    href={url}
                                    className="text-s"
                                    dataEventLocation="footer_link"
                                    {...(new_tab
                                        ? {
                                              target: '_blank',
                                              rel: 'noreferrer',
                                          }
                                        : {})}
                                >
                                    {text}
                                </TextLink>
                            )
                        )}
                    </div>
                    <FooterSocials data={data.allFlotiqMainSettings.nodes[0]} />
                </div>
                <div className="main-footer-ue mt-3 mb-3">
                    <img
                        width={785}
                        height={75}
                        src={FooterBottomImage}
                        alt="European Funds Smart Growth,
                           Republic of Poland,
                           Polish Investment & Trade Agency PFR Group,
                           European Union European Regional Development Fund"
                    />
                </div>
            </div>
        </footer>
    );
};

const query = graphql`
    query FooterQuery {
        allFlotiqMainSettings {
            nodes {
                app_store_url
                discord_url
                facebook_url
                footer_1_column_header
                footer_2_column_header
                footer_3_column_header
                github_url
                google_play_url
                linkedin_url
                twitter_url
                youtube_url
                reddit_url
                footer_1_column {
                    text
                    url
                    new_tab
                }
                footer_2_column {
                    text
                    url
                    new_tab
                }
                footer_3_column {
                    text
                    url
                    new_tab
                }
                footer_legal {
                    text
                    url
                    new_tab
                }
            }
        }
    }
`;

export default Footer;
